import React from 'react';
import { AppCard } from 'app/javascript/components/ui/app-card';
import { AppAlert, AppAlertDescription } from 'app/javascript/components/ui/app-alert';

type Props = {
  /** カードの上、ロゴの下に出す画面の名称（例: 「TABETE 店舗管理画面」）。省略時はロゴのみ */
  brand?: string | null;
  title: string;
  description?: string | null;
  /** Devise の flash[:alert] や resource.errors。カード内に role="alert" で表示する */
  errorMessage?: string | null;
  /** カードの下に出す小さな文言（コピーライト等） */
  footer?: string | null;
  children: React.ReactNode;
};

/**
 * 未ログイン画面（ログイン・パスワード再設定）共通のカード枠。
 * モックに合わせ、ロゴと画面名はカードの外に中央寄せで置く。
 * レイアウトは admin_page/not_logged_in を前提にしている。
 */
const AuthCard: React.FC<Props> = ({ brand, title, description, errorMessage, footer, children }) => (
  <div className="flex min-h-screen items-center justify-center bg-muted px-4">
    <div className="w-full max-w-sm">
      <div className="mb-5 flex flex-col items-center gap-3">
        <img src="/tabete-icon.png" alt="TABETE" className="size-15 rounded-2xl object-cover shadow-md" />
        {brand && <span className="text-title font-bold tracking-wide text-foreground">{brand}</span>}
      </div>
      <AppCard className="gap-0 px-9 py-10 shadow-xs">
        <h1 className="mb-1.5 text-center text-heading font-bold text-foreground">{title}</h1>
        {description && (
          <p className="mb-6 text-center text-subtitle leading-relaxed text-tt-foreground-sub">{description}</p>
        )}
        {!description && <div className="mb-4" />}

        {errorMessage && (
          <AppAlert variant="destructive" className="mb-4">
            <AppAlertDescription className="text-subtitle">{errorMessage}</AppAlertDescription>
          </AppAlert>
        )}

        {children}
      </AppCard>
      {footer && <p className="mt-5 text-center text-caption text-muted-foreground">{footer}</p>}
    </div>
  </div>
);

export default AuthCard;
